<template>
  <div class="header">
    <div class="header-left">{{ beginTimeStamp }}-{{ roomId }}</div>
    <div class="header-right">
      <div class="header-right-time" @click="checkInChange">
        <div id="timer2" v-html="time"></div>

        <div class="onoffswitch" v-if="isCheckAll == true" v-show="!startClass">
          <input
            type="checkbox"
            name="switch"
            class="onoffswitch-checkbox"
            id="switch_00"
            checked=""
            @click="checkAll()"
            v-model="isCheckAll"
            ref="toEndButton"
          />

          <label class="onoffswitch-label" for="switch_00">
            <span class="onoffswitch-inner"></span>
            <span class="onoffswitch-switch"></span>
          </label>
        </div>

        <div
          class="onoffswitch"
          v-if="isCheckAll == false"
          v-show="!startClass"
        >
          <input
            type="checkbox"
            name="switch"
            class="onoffswitch-checkbox"
            id="switch_00"
            checked=""
            @click="checkAll()"
            v-model="isCheckAll"
            :disabled="countdownTimerDisable"
            ref="toStartButton"
          />
          <label class="onoffswitch-label" for="switch_00">
            <span class="onoffswitch-inner"></span>
            <span class="onoffswitch-switch"></span>
          </label>
        </div>
      </div>

      <div class="header-right-icon" @click="quitOpen">
        <img src="@/assets/image/icon-quit.png" alt="" />
      </div>
    </div>

    <!-- 離開教室彈窗 -->
    <transition name="el-fade-in">
      <div class="popup" v-show="quitShow">
        <transition name="el-zoom-in-center">
          <div class="popup-box quit-box" v-if="quitShow">
            <div class="box-img">
              <img src="@/assets/image/popup-quit.png" alt="離開" />
            </div>
            <h3 class="box-h3">確定離開教室顯示</h3>
            <h5 class="box-h5">
              Are you sure you want to leave the classroom?
            </h5>
            <div class="box-btn">
              <button class="button1" @click="quitCancel">
                <p>取消</p>
                <span>Cancel</span>
              </button>
              <button @click="quitSubmit">
                <p>確定</p>
                <span>YES</span>
              </button>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "student-header",
  props: {
    // 視訊列表
    agoraCamerasList: {
      type: Array,
      default: () => [],
    },
    // 音頻列表
    agoraMicrophoneList: {
      type: Array,
      default: () => [],
    },
    // 喇叭列表
    agoraSpeakerList: {
      type: Array,
      default: () => [],
    },
  },
  async mounted() {
    this.roomId = this.$store.state.classRoomId;
    this.beginTimeStamp = moment
      .unix(this.$store.state.BeginTimeStamp)
      .format("LLLL");

    this.LessonRecordUrl = this.$store.state.LessonRecordUrlStore;
    this.TBUrl = this.$store.state.TBUrlStore;
    this.getClassTime();
  },
  data() {
    return {
      LessonRecordUrl: "",
      TBUrl: "",
      roomId: "",
      beginTimeStamp: 0,

      checkInStatus: false,
      // 打卡彈窗狀態
      checkInShow: false,

      // 屏幕分享彈窗狀態
      screenShareShow: false,
      // 呼叫客服彈窗狀態
      serviceShow: false,
      // 呼叫客服成功提示彈窗狀態
      serviceNotifyShow: false,
      // 有人進入教室彈窗
      joinClassroomShow: false,
      // 進入教室用戶名
      joinClassroomUserName: "",
      // 設備設定彈窗狀態
      deviceShow: false,
      // 離開教室彈窗狀態
      quitShow: false,

      // 視訊選中
      cameraCheck: "",
      // 麥克風選中
      microphoneCheck: "",
      // 喇叭選中
      speakerCheck: "",
      startClass: false,
      isCheckAll: false,
      stateTime: true,
      currentTime: Date.now(),
      intervalTime: null,
      initialHour: 0,
      initialMin: 0,
      initialSec: 0,
      initialMilliSec: 0,
      message: "Let the countdown begin!!",
      totalTime: this.$store.state.classTime * 60,
      timerRunning: false,
      interval: null,
      checkingTimer: null,
      nowDateTime: null,
      countdownTimerDisable: true,
      enableTimerEvery10s: true,
      showAlertCheckIn: 0,
      checkTimerData: 0,
    };
  },
  computed: {
    cameraList() {
      this.cameraCheck = this.agoraCamerasList?.[0]?.deviceId || "";
      return this.agoraCamerasList;
    },
    microphoneList() {
      this.microphoneCheck = this.agoraMicrophoneList?.[0]?.deviceId || "";
      return this.agoraMicrophoneList;
    },
    speakerList() {
      this.speakerCheck = this.agoraSpeakerList?.[0]?.deviceId || "";
      return this.agoraSpeakerList;
    },

    time: function () {
      return this.hours + " : " + this.minutes + " : " + this.seconds;
    },
    milliseconds: function () {
      return this.currentTime;
    },
    hours: function () {
      var milli = this.milliseconds;
      var hrs = Math.floor(this.totalTime / 3600);
      return hrs >= 10 ? hrs : "0" + hrs;
      // let h = Math.trunc((this.endDate - this.nowz) / 1000 / 3600);
      // return h>9?h:'0'+h;
    },
    minutes: function () {
      var min = Math.floor((this.totalTime % 3600) / 60);
      return min >= 10 ? min : "0" + min;
      // let m = Math.trunc((this.endDate - this.nowz) / 1000 / 60) % 60;
      // return m>9?m:'0'+m;
    },
    seconds: function () {
      var sec = this.totalTime % 60;
      return sec >= 10 ? sec : "0" + sec;
      // let s = Math.trunc((this.endDate - this.nowz)/1000) % 60
      // return s>9?s:'0'+s;
    },
    ...mapGetters([
      "teacher_start_class",
      "classRoomId",
      "BeginTimeStamp",
      "EndTimeStamp",
    ]),
  },
  watch: {
    // 監聽客服呼叫成功彈窗 五秒後關閉
    serviceNotifyShow: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.serviceNotifyShow = false;
          }, 5000);
        }
      },
      immediate: true,
    },
    // 監聽進入教室彈窗 三秒後關閉
    joinClassroomShow: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.joinClassroomShow = false;
          }, 4000);
        }
      },
      immediate: true,
    },
  },
  methods: {
    getClassTime() {
      return this.$axios
        .get(`/classroom/info?classRoomId=${this.classRoomId}`)
        .then((response) => {
          if (
            response.data.payload.classRoom != null &&
            response.data.payload.classRoom != undefined
          ) {
            const initialTime = this.$store.state.classTime * 60;
            const savedTime = response.data.payload.classRoom.classTime;
            this.totalTime = savedTime > 0 ? savedTime : initialTime;
          }
        });
    },
    checkStartClassState() {
      if (this.teacher_start_class) {
        this.countdownTimerDisable = false;
        this.checkAll();
      } else {
        this.countdownTimerDisable = false;
      }
    },
    // 打卡狀態切換
    checkInChange() {
      this.checkInStatus = !this.checkInStatus;
      // 打開彈窗
      this.checkInShow = true;
    },
    // 打卡彈窗關閉（click here）
    checkInClose() {
      this.checkInShow = false;
    },
    timerFunction() {
      this.intervalTime = setInterval(this.updateCurrentTime, 1000);
    },
    async checkAll() {
      this.timerFunction();
      if (this.isCheckAll == false) {
        this.timerRun();
        clearInterval(this.checkingTimer);
      } else {
        this.timerPause();
      }
    },
    setClockIn(val) {
      if (val) {
        this.totalTime = val.timeNow;
        this.isCheckAll = false;
        this.checkAll();
      }
    },
    setClockOut() {
      this.isCheckAll = true;
      this.checkAll();
    },
    timerRun() {
      this.startClass = true;
      this.timerRunning = true;
      this.message = "Greatness is within sight!!!";
      this.interval = setInterval(this.countdownTimer, 1000);
    },
    timerPause() {
      this.message = "Never quit, keep going!!";
      this.timerRunning = false;
      clearInterval(this.interval);
    },

    countdownTimer() {
      if (this.timerRunning == true) {
        if (this.totalTime > 0) {
          this.totalTime--;
        } else {
          // const elemToEndButton = this.$refs.toEndButton;
          // elemToEndButton.click();
          // this.countdownTimerDisable = true;
        }
      }
    },

    goToTbUrl() {
      window.open(this.TBUrl, "_blank").focus();
    },

    goToLessonRecord() {
      window.open(this.LessonRecordUrl, "_blank").focus();
    },

    // 用戶加入教室
    enteredHandel(uid) {
      // 根據uid區分角色 13老師 23學生 33客服
      const type = uid.toString().slice(0, 2);
      if (type == 13) {
        this.joinClassroomUserName = "老師";
        this.joinClassroomShow = true;
      }
      if (type == 23) {
        this.joinClassroomUserName = "學生";
        this.joinClassroomShow = true;
      }
      if (type == 33) {
        this.joinClassroomUserName = "客服";
        this.joinClassroomShow = true;
      }
    },
    // 呼叫客服彈窗打開
    serviceOpen() {
      this.serviceShow = true;
    },
    // 呼叫客服彈窗（取消）
    serviceCancel() {
      this.serviceShow = false;
    },
    // 呼叫客服彈窗（確定）
    serviceSubmit() {
      this.serviceShow = false;
      this.serviceNotifyShow = true;
      this.$store.dispatch("callCustomer", {
        ClassroomId: this.$store.state.classRoomId,
      });
    },
    // 設備設定彈窗打開
    deviceOpen() {
      this.deviceShow = true;
    },
    // 設備設定彈窗打開
    deviceClose() {
      this.deviceShow = false;
    },
    // 設備設定-視訊切換
    cameraChange() {
      this.$emit("cameraChange", this.cameraCheck);
    },
    // 設備設定-麥克風切換
    microphoneChange() {
      this.$emit("microphoneChange", this.microphoneCheck);
    },
    // 設備設定-喇叭切換
    speakerChange() {
      this.$emit("speakerChange", this.speakerCheck);
    },

    // 離開教室彈窗打開
    quitOpen() {
      this.quitShow = true;
    },
    // 離開教室彈窗（取消）
    quitCancel() {
      this.quitShow = false;
    },
    // 離開教室彈窗（確定）
    quitSubmit() {
      this.quitShow = false;
      this.$emit("exitClassroom");
      // alert("You will leave classroom");
      // this.agoraVideoRemoteUsers = {};
      // this.agoraAudioRemoteUsers = {};
      // this.agoraCameraLeave();
      // this.agoraScreenLeave();
      // sessionStorage.clear();
      // this.$router.push("/?key=");
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  padding: 0 26px;
  width: 100%;
  height: 60px;
  border-bottom: 1px solid var(--gray-100, #f3f4f6);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .header-left {
    color: #000;
    font-size: 16px;
    font-family: Microsoft JhengHei;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .header-right {
    display: flex;
    align-items: center;
    .header-right-time {
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000;
      font-size: 14px;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.14px;
      img {
        margin-left: 14px;
        width: 28px;
        height: 24px;
      }
    }
    .header-right-record {
      margin-left: 16px;
      user-select: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #f00;
      font-size: 14px;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.14px;
      img {
        margin-left: 8px;
        width: 16px;
        height: 16px;
      }
    }
    .header-right-icon {
      cursor: pointer;
      margin-left: 16px;
      width: 42px;
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      &:hover {
        background: var(--gray-100, #f3f4f6);
      }
    }
  }
  // 打卡彈窗樣式
  .checkIn-box {
    .box-img {
      margin-bottom: 16px;
      padding: 12px 70px;
      text-align: center;
      img {
        width: 70px;
        height: 70px;
      }
    }
    .box-h3 {
      color: #000;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-h5 {
      margin: 4px 0 33px;
      color: #666;
      text-align: center;
      font-size: 14px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-btn {
      user-select: none;
      cursor: pointer;
      width: 230px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      border-radius: 4px;
      background: linear-gradient(180deg, #71afff 0%, #418ef2 100%);
      color: #fff;
      font-size: 15px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
  // 熒幕分享彈窗樣式
  .screenShare-box {
    .box-h3 {
      color: #000;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-h5 {
      margin-top: 12px;
      color: #666;
      text-align: center;
      font-size: 14px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-btn {
      margin-top: 33px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        user-select: none;
        cursor: pointer;
        width: 230px;
        height: 48px;
        border: none;
        border-radius: 4px;
        background: linear-gradient(180deg, #71afff 0%, #418ef2 100%);
        color: #fff;
        text-align: center;
        p {
          width: 100%;
          color: #fff;
          font-size: 15px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin: 0;
        }
        span {
          color: #fff;
          font-size: 12px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }
  }
  // 呼叫客服彈窗樣式
  .service-box {
    .box-img {
      text-align: center;
      img {
        width: 210px;
        height: 126px;
      }
    }
    .box-h3 {
      color: #000;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-h5 {
      margin-top: 4px;
      color: #666;
      text-align: center;
      font-size: 14px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-btn {
      margin-top: 33px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        user-select: none;
        cursor: pointer;
        width: 133px;
        height: 48px;
        border: none;
        border-radius: 4px;
        background: linear-gradient(180deg, #71afff 0%, #418ef2 100%);
        color: #fff;
        text-align: center;
        p {
          width: 100%;
          color: #fff;
          font-size: 15px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin: 0;
        }
        span {
          color: #fff;
          font-size: 12px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
      .button1 {
        margin-right: 14px;
        background: #ececec;
        p {
          color: #666;
        }
        span {
          color: #666;
        }
      }
    }
  }
  // 呼叫客服成功通知
  .notify-popup {
    position: fixed;
    left: 110px;
    bottom: 80px;
    padding: 24px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.8);
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05);
    .notify-popup-p {
      color: #fff;
      text-align: center;
      font-size: 16px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .notify-popup-span {
      margin-top: 10px;
      color: #fff;
      font-size: 16px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
  // 設備設定彈窗樣式
  .device-popup {
    z-index: 1100;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    .popup-box {
      padding: 40px 0;
      width: 600px;
      border-radius: 16px;
      background: #fff;
      position: relative;
      .box-close {
        cursor: pointer;
        user-select: none;
        position: absolute;
        top: 30px;
        right: 24px;
        width: 40px;
        height: 40px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background: #f3f4f6;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .box-h2 {
        padding: 0 60px 20px;
        color: #000;
        font-size: 23px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .box-hr {
        width: 100%;
        height: 1px;
        background: #e9e9ea;
      }
      .box-label {
        padding: 20px 60px 14px;
        color: #989898;
        font-size: 16px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .box-select {
        padding: 0 60px 10px;
        width: 100%;
        height: 50px;
        ::v-deep .el-select {
          width: 100%;
          height: 100%;
          .el-input {
            width: 100%;
            height: 100%;
            .el-input__inner {
              width: 100%;
              height: 100%;
              border: 1px solid #eee;
              color: #000;
              font-size: 16px;
              font-family: Microsoft JhengHei;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }
          }
        }
      }
    }
  }
  // 離開教室彈窗樣式
  .quit-box {
    .box-img {
      margin: 0 auto 16px;
      padding: 12px 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 68px;
        height: 56px;
      }
    }
    .box-h3 {
      color: #000;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-h5 {
      margin-top: 4px;
      color: #666;
      text-align: center;
      font-size: 14px;
      font-family: Microsoft JhengHei;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .box-btn {
      margin-top: 33px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        user-select: none;
        cursor: pointer;
        width: 133px;
        height: 48px;
        border: none;
        border-radius: 4px;
        background: linear-gradient(180deg, #71afff 0%, #418ef2 100%);
        color: #fff;
        text-align: center;
        p {
          width: 100%;
          color: #fff;
          font-size: 15px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin: 0;
        }
        span {
          color: #fff;
          font-size: 12px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
      .button1 {
        margin-right: 14px;
        background: #ececec;
        p {
          color: #666;
        }
        span {
          color: #666;
        }
      }
    }
  }
}
.header-right-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .header-right-icon {
    cursor: pointer;
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    &:hover {
      background: var(--gray-100, #f3f4f6);
    }
    img {
      width: 24px;
      height: 24px;
    }
  }
}
</style>

<style>
.header-popover {
  min-width: 110px;
  padding: 10px !important;
}
</style>

<style>
.header-popover {
  min-width: 110px;
  padding: 10px !important;
}

.onoffswitch {
  position: relative;
  width: 88px;
  display: inline-block;
  margin: auto 0 auto 10px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.onoffswitch .onoffswitch-checkbox {
  display: none;
}

.onoffswitch
  .onoffswitch-checkbox:checked
  + .onoffswitch-label
  .onoffswitch-inner {
  margin-left: 0;
}

.onoffswitch
  .onoffswitch-checkbox:checked
  + .onoffswitch-label
  .onoffswitch-switch {
  right: 0px;
}

.onoffswitch .onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 20px;
  margin-bottom: 0;
}

.onoffswitch .onoffswitch-label .onoffswitch-inner {
  display: block;
  width: 200%;
  margin-left: -100%;
  -webkit-transition: margin 0.3s ease-in 0s;
  transition: margin 0.3s ease-in 0s;
}

.onoffswitch .onoffswitch-label .onoffswitch-inner:before,
.onoffswitch .onoffswitch-label .onoffswitch-inner:after {
  display: block;
  float: left;
  width: 50%;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  font-weight: bold;
  padding: 0;
  color: white;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.onoffswitch .onoffswitch-label .onoffswitch-inner:before {
  content: "START";
  padding-left: 10px;
  background-color: var(--time-ctrl-btn);
  color: #ffffff;
  text-align: left;
}

.onoffswitch .onoffswitch-label .onoffswitch-inner:after {
  content: "END";
  padding-right: 10px;
  background-color: #9a9a9a;
  color: #252525;
  text-align: right;

  font-size: 14px;
  font-family: Roboto;
  font-style: normal;
}

.onoffswitch .onoffswitch-label .onoffswitch-switch {
  display: block;
  width: 18px;
  height: 18px;
  margin: 5px;
  background: #ffffff;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 60px;
  border: 2px solid #ffffff;
  border-radius: 24px;
  -webkit-transition: all 0.3s ease-in 0s;
  transition: all 0.3s ease-in 0s;
}
</style>
